import { Directive, ElementRef, EventEmitter, HostListener, Input, Output } from '@angular/core';

@Directive({
  selector: '[clickOutside]'
})
export class ClickOutsideDirective {
  @Output() clickOutside = new EventEmitter<MouseEvent>();
  @Input() exclude: Array<ElementRef> = [];

  constructor(private elementRef: ElementRef) { }

  @HostListener('document:click', ['$event'])
  onClick(event: MouseEvent): void {
    const clickedInside = this.elementRef.nativeElement.contains(event.target);
    const clickedExcluded = Array.isArray(this.exclude) && 
      this.exclude.some(ref => ref?.nativeElement?.contains(event.target));
    
    if (!clickedInside && !clickedExcluded) {
      this.clickOutside.emit(event);
    }
  }
}
